var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { mockData as users } from '@web/lib/demo/data/users';
export var updateUser = function (input) {
    var user = users.find(function (user) { return user.id === input.userId; });
    if (!user) {
        throw new Error('User not found');
    }
    return __assign(__assign({}, user), { role: user.role });
};
